import React, { useState, useEffect } from 'react';
import axios from 'axios';
import WordCloud from './WordCloud';

function TeacherPage() {
  const [qrCode, setQrCode] = useState('');
  const [sessionId, setSessionId] = useState('');
  const [questions, setQuestions] = useState([]);
  const [newQuestion, setNewQuestion] = useState({ title: '', content: '' });
  const [showQuestionForm, setShowQuestionForm] = useState(false);
  const [showWordCloud, setShowWordCloud] = useState(false);
  const [wordCloudData, setWordCloudData] = useState([]);
  const [teacherPassword, setTeacherPassword] = useState('');
  const [showPasswordDialog, setShowPasswordDialog] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState({ show: false, questionId: null, title: '' });

  useEffect(() => {
    generateQRCode();
    fetchQuestions();
  }, []);

  const generateQRCode = async () => {
    try {
      // 获取当前端口
      const currentPort = window.location.port || '3000';
      const response = await axios.get(`/api/qrcode?port=${currentPort}`, {
        headers: {
          'x-frontend-origin': window.location.origin
        }
      });
      setQrCode(response.data.qrCode);
      setSessionId(response.data.sessionId);
    } catch (error) {
      console.error('生成二维码失败:', error);
    }
  };

  const fetchQuestions = async () => {
    try {
      const response = await axios.get('/api/questions');
      setQuestions(response.data);
    } catch (error) {
      console.error('获取题目失败:', error);
    }
  };

  const createQuestion = async (e) => {
    e.preventDefault();
    if (!newQuestion.title || !newQuestion.content) return;

    try {
      await axios.post('/api/questions', newQuestion);
      setNewQuestion({ title: '', content: '' });
      setShowQuestionForm(false);
      fetchQuestions();
    } catch (error) {
      console.error('创建题目失败:', error);
    }
  };

  const fetchWordCloud = async () => {
    try {
      const response = await axios.get('/api/wordcloud');
      setWordCloudData(response.data);
      setShowWordCloud(true);
    } catch (error) {
      console.error('获取词云数据失败:', error);
    }
  };

  const handleTeacherAuth = async (e) => {
    e.preventDefault();
    
    try {
      const response = await axios.post('/api/teacher-auth', {
        password: teacherPassword
      });
      
      if (response.data.success) {
        // 保存教师用户信息到 localStorage
        localStorage.setItem('user', JSON.stringify(response.data.user));
        setShowPasswordDialog(false);
        setTeacherPassword('');
        
        // 在新窗口打开弹幕页面
        window.open('/danmu', '_blank');
      }
    } catch (error) {
      alert('密码错误，请重试');
      setTeacherPassword('');
    }
  };

  const handleDeleteQuestion = (questionId, title) => {
    setDeleteConfirm({ show: true, questionId, title });
  };

  const confirmDeleteQuestion = async () => {
    try {
      await axios.delete(`/api/questions/${deleteConfirm.questionId}`);
      setDeleteConfirm({ show: false, questionId: null, title: '' });
      fetchQuestions(); // 重新获取题目列表
      alert('题目删除成功');
    } catch (error) {
      alert('删除失败，请重试');
    }
  };

  const cancelDeleteQuestion = () => {
    setDeleteConfirm({ show: false, questionId: null, title: '' });
  };

  return (
    <div className="container">
      <h1>教师控制台</h1>
      
      <div className="qr-container">
        <h2>学生扫码加入</h2>
        {qrCode && (
          <div className="qr-code">
            <img src={qrCode} alt="二维码" style={{width: '200px', height: '200px'}} />
          </div>
        )}
        <p>会话ID: {sessionId}</p>
        {sessionId && (
          <div style={{marginTop: '10px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '4px'}}>
            <p style={{margin: '0 0 5px 0', fontSize: '14px', color: '#666'}}>学生加入链接：</p>
            <p style={{margin: '0', wordBreak: 'break-all', fontSize: '12px'}}>
              {window.location.origin}/join?session={sessionId}
            </p>
          </div>
        )}
        <button className="btn" onClick={generateQRCode}>
          重新生成二维码
        </button>
      </div>

      <div style={{marginTop: '40px'}}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <h2>题目管理</h2>
          <button 
            className="btn" 
            onClick={() => setShowQuestionForm(!showQuestionForm)}
          >
            {showQuestionForm ? '取消' : '添加题目'}
          </button>
        </div>

        {showQuestionForm && (
          <form onSubmit={createQuestion} className="form-container">
            <div className="form-group">
              <label>题目标题:</label>
              <input
                type="text"
                value={newQuestion.title}
                onChange={(e) => setNewQuestion({...newQuestion, title: e.target.value})}
                placeholder="请输入题目标题"
                required
              />
            </div>
            <div className="form-group">
              <label>题目内容:</label>
              <textarea
                value={newQuestion.content}
                onChange={(e) => setNewQuestion({...newQuestion, content: e.target.value})}
                placeholder="请输入题目内容"
                rows="4"
                required
              />
            </div>
            <button type="submit" className="btn">创建题目</button>
          </form>
        )}

        <div style={{marginTop: '20px'}}>
          {questions.map(question => (
            <div key={question.id} className="question-item" style={{
              border: '1px solid #ddd',
              padding: '15px',
              marginBottom: '10px',
              borderRadius: '5px',
              position: 'relative'
            }}>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                <div style={{flex: 1}}>
                  <h3 style={{marginBottom: '10px'}}>{question.title}</h3>
                  <p style={{marginBottom: '10px'}}>{question.content}</p>
                  <small>创建时间: {new Date(question.created_at).toLocaleString()}</small>
                </div>
                <button 
                  onClick={() => handleDeleteQuestion(question.id, question.title)}
                  style={{
                    background: '#dc3545',
                    color: 'white',
                    border: 'none',
                    padding: '5px 10px',
                    borderRadius: '3px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  删除
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{marginTop: '40px', display: 'flex', gap: '10px'}}>
        <button 
          className="btn" 
          onClick={() => setShowPasswordDialog(true)}
        >
          查看弹幕显示（教师模式）
        </button>
        <button 
          className="btn btn-secondary" 
          onClick={() => window.open('/admin', '_blank')}
        >
          后台管理
        </button>
        <button 
          className="btn btn-info" 
          onClick={fetchWordCloud}
          style={{
            backgroundColor: '#17a2b8',
            borderColor: '#17a2b8',
            color: 'white'
          }}
        >
          显示词云
        </button>
      </div>

      {/* 词云显示区域 */}
      {showWordCloud && (
        <WordCloud 
          data={wordCloudData} 
          onClose={() => setShowWordCloud(false)} 
        />
      )}

      {/* 教师密码认证对话框 */}
      {showPasswordDialog && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            width: '400px'
          }}>
            <h3 style={{marginBottom: '20px'}}>教师认证</h3>
            <form onSubmit={handleTeacherAuth}>
              <div className="form-group">
                <label>请输入教师密码：</label>
                <input
                  type="password"
                  value={teacherPassword}
                  onChange={(e) => setTeacherPassword(e.target.value)}
                  placeholder="输入密码"
                  required
                  autoFocus
                />
              </div>
              <div style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                <button type="submit" className="btn">确认</button>
                <button 
                  type="button" 
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowPasswordDialog(false);
                    setTeacherPassword('');
                  }}
                >
                  取消
                </button>
              </div>
            </form>
            <p style={{marginTop: '15px', fontSize: '14px', color: '#666'}}>
              提示：默认密码是 teacher123
            </p>
          </div>
        </div>
      )}

      {/* 删除确认对话框 */}
      {deleteConfirm.show && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            width: '400px'
          }}>
            <h3 style={{marginBottom: '20px', color: '#dc3545'}}>确认删除</h3>
            <p style={{marginBottom: '20px', color: '#666'}}>
              您确定要删除题目 "<strong>{deleteConfirm.title}</strong>" 吗？
            </p>
            <p style={{marginBottom: '20px', fontSize: '14px', color: '#999'}}>
              删除后将无法恢复，与此题目相关的弹幕也会受到影响。
            </p>
            <div style={{display: 'flex', gap: '10px', justifyContent: 'flex-end'}}>
              <button 
                onClick={cancelDeleteQuestion}
                className="btn btn-secondary"
                style={{
                  background: '#6c757d',
                  borderColor: '#6c757d'
                }}
              >
                取消
              </button>
              <button 
                onClick={confirmDeleteQuestion}
                className="btn"
                style={{
                  background: '#dc3545',
                  borderColor: '#dc3545'
                }}
              >
                确认删除
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TeacherPage;